"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.ProviderDescription = exports.PaymentProviderBox = exports.PaymentHeader = exports.LazyImageTopIcon = exports.Description = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('section')(({
  theme
}) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 740,
  padding: theme.spacing(4, 3),
  [theme.breakpoints.up('sm')]: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4, 6)
  }
}));
const Description = exports.Description = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.grey[500],
  margin: theme.spacing(2, 0, 4),
  display: 'flex',
  flexDirection: 'row'
}));
const ProviderDescription = exports.ProviderDescription = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginTop: theme.spacing(2)
}));
const LazyImageTopIcon = exports.LazyImageTopIcon = (0, _mui.styled)(_components.LazyImage)({
  display: 'inline-block',
  height: 25,
  objectFit: 'contain',
  marginLeft: 'auto',
  lineHeight: '1',
  // TODO -- was [`& .${lazyImageClasses.image}`]: { ... }, but the override didn't work
  [`& img`]: {
    width: 'auto'
  }
});
const PaymentHeader = exports.PaymentHeader = (0, _mui.styled)('div')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'flex',
  flexWrap: 'wrap'
});
const PaymentProviderBox = exports.PaymentProviderBox = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isActive
  }
}) => ({
  padding: theme.spacing(3),
  position: 'relative',
  display: 'block',
  borderRadius: theme.spacing(2),
  cursor: 'pointer',
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.default.main,
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
  transition: 'box-shadow 300ms, border-color 300ms',
  ...(isActive && {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.primary.main}`
  }),
  ...(!isActive && {
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        border: `1px solid ${theme.palette.background.paper}`,
        boxShadow: _mui.SHADOW_LEVEL2
      }
    }
  })
}));